import { onScopeDispose, readonly, shallowRef, toValue, watch, type MaybeRefOrGetter } from 'vue';

/**
 * An object URL for a blob that follows the blob: when the source changes the
 * old URL is revoked and a new one made, and the last one is revoked when the
 * component (or effect scope) goes away. `undefined` while there is no blob.
 *
 *     const url = useObjectUrl(() => props.file);
 *     // <img :src="url">
 */
export function useObjectUrl(source: MaybeRefOrGetter<Blob | null | undefined>) {
  const url = shallowRef<string | undefined>();

  const release = () => {
    if (url.value) URL.revokeObjectURL(url.value);
    url.value = undefined;
  };

  watch(
    () => toValue(source),
    (blob) => {
      release();
      if (blob) url.value = URL.createObjectURL(blob);
    },
    { immediate: true }
  );
  onScopeDispose(release);

  return readonly(url);
}
